import React from "react";
import Product from "./Product";
import UnitPrice from "./UnitPrice";
import Description from "./Description";
import ModelAndOption from "./ModelAndOption";
import AdditionalInfo from "./AdditionalInfo";
import Rating from "./Rating";

const CompareItemTable = () => (
  <div className="row">
    <div className="col-lg-12">
      <div className="compare-page-content">
        <div className="compare-table table-responsive">
          <table className="table table-bordered mb-0">
            <tbody>
              <Product />
              <UnitPrice />
              <Description />
              <ModelAndOption />
              <AdditionalInfo />
              {/* <Rating /> */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default CompareItemTable;
